import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["buttonOpen", "buttonClose"];

  open(e) {
    e.preventDefault();

    const itemElement = e.currentTarget.closest(".categories__item");
    if (!itemElement) return;

    const body = itemElement.querySelector(".categories__item-features");
    const buttonOpen = itemElement.querySelector(".categories__item-features-button.open");
    const buttonClose = itemElement.querySelector(".categories__item-features-button.close");
    const panelRightBottom = itemElement.querySelector(".categories__item-price-box");

    body.classList.add("opened");
    body.classList.remove("closed");
    buttonOpen.style.display = "none";
    buttonClose.style.display = "flex";
    setTimeout(() => {
      panelRightBottom.classList.add("opened")
      panelRightBottom.classList.remove("closed")
    }, 200)
  }

  close(e) {
    e.preventDefault();

    const itemElement = e.currentTarget.closest(".categories__item");
    if (!itemElement) return;

    const body = itemElement.querySelector(".categories__item-features");
    const buttonOpen = itemElement.querySelector(".categories__item-features-button.open");
    const buttonClose = itemElement.querySelector(".categories__item-features-button.close");
    const panelRightBottom = itemElement.querySelector(".categories__item-price-box");

    body.classList.add("closed");
    body.classList.remove("opened");
    buttonOpen.style.display = "flex";
    buttonClose.style.display = "none";
    panelRightBottom.classList.add("closed")
    panelRightBottom.classList.remove("opened")
  }
}
